import React, { useEffect, useState } from "react";

export default function SummaryForm({ parsed, setParsed, onDone }) {
  const [draft, setDraft] = useState(parsed?.summary || "");

  useEffect(() => {
    setDraft(parsed?.summary || "");
  }, [parsed?.summary]);

  const handleSave = () => {
    setParsed((prev) => ({ ...prev, summary: draft }));
    if (typeof onDone === "function") onDone();
  };

  return (
    <div className="mt-5 p-5 bg-gray-800 rounded-xl border border-white/10">
      <h3 className="text-lg font-bold mb-3">Edit Summary</h3>

      <textarea
        className="w-full p-3 bg-gray-700 rounded-lg border border-white/10"
        rows={6}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
      />

      <div className="mt-3 flex gap-2">
        <button
          type="button"
          onClick={handleSave}
          className="bg-gradient-to-r from-[#EB6AB5] to-[#ff83d1] text-[#0F0A24]
            px-5 py-2 rounded-full font-bold hover:opacity-95 transition"
        >
          Save
        </button>

        <button
          type="button"
          onClick={() => setDraft(parsed?.summary || "")}
          className="px-5 py-2 rounded-full bg-white/5 border border-white/10 hover:bg-white/10"
        >
          Reset
        </button>
      </div>
    </div>
  );
}